import { useQuery } from "react-query";
import { http } from "./http";

export interface ConfigurationModel {
    applicationInstallerWindowsUrl: string,
    applicationInstallerMacOSUrl: string,
    version: string,
    appVersion: string,
    flags: {
        EnableArtistSelector?: boolean,
        EnableAIChat?: boolean,
        EnableSocialAIChat?: boolean,
        EnableAnalytics?: boolean,
        EnableMyFans?: boolean,
        EnableTwilio?: boolean,
        EnablePosting?: boolean
    }
}

export function useConfiguration() {
    return useQuery<ConfigurationModel>({
        //placeholderData: {},
        queryKey: ["configuration"],
        queryFn: () => http("/api/configuration"),
        staleTime: 5000
    });
}